const fileMarkAsProcessed = (file) => {
    file.wasProcessedBefore = true
    return file
}

export default fileMarkAsProcessed